import React from 'react';
import tpl from '../templates/light-house';
import BaseNewCardView from '../../../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'Gov.LightHouse';
}
